import axios from 'axios';
import { getApiUrl } from '../utils/loginProvider';

const axiosInstance = axios.create({
    baseURL: getApiUrl()
});

export default axiosInstance;
